
export interface INickInputArtifact {
    calculateField?: any[];
    model?: string;
    data?: any;
    config?: any;
}
